let dpr = window.devicePixelRatio;//获取设备dpr
const mockData = {
    piechartsData:{//房企拿地属性占比(饼图)
        series:{
            name:'房企拿地属性占比',
            data:[
                {value:36, name:'纯住宅'},
                {value:10, name:'商住'},
                {value:20, name:'商办'},
                {value:10, name:'综合'},
                {value:40, name:'工业'},
                {value:20, name:'其他'},
            ]
        }
    },
    getlandBarData:[//房企拿地(带分隔进度条)
        {name:'恒大',value:100,status:'up',changeValue:'35%'},
        {name:'万科',value:80,status:'up',changeValue:'31%'},
        {name:'旭辉',value:70,status:'up',changeValue:'15%'},
        {name:'远洋',value:60,status:'up',changeValue:'15%'},
        {name:'绿地',value:60,status:'down',changeValue:'25%'},
        {name:'绿城',value:60,status:'up',changeValue:'15%'},
        {name:'首开',value:50,status:'down',changeValue:'25%'},
        {name:'首开',value:50,status:'down',changeValue:'25%'},
        {name:'首开',value:50,status:'down',changeValue:'25%'},
        {name:'首开',value:50,status:'down',changeValue:'25%'},
    ],
    landTransferBarData:[//土地出让幅数(进度条)
        {name:'北京',value:110},
        {name:'上海',value:90},
        {name:'广州',value:80},
        {name:'深圳',value:70},
        {name:'杭州',value:70},
        {name:'南京',value:70},
        {name:'武汉',value:60},
    ],
    landTransactionData:[//最新土地成交
        {name:'武告字（2018年）23号',Transferee:'葛洲坝',time:'2018.11.28',isNew:true},
        {name:'武告字（2018年）23号',Transferee:'葛洲坝',time:'2018.11.28',isNew:true},
        {name:'武告字（2018年）23号',Transferee:'葛洲坝',time:'2018.11.28',isNew:false},
        {name:'武告字（2018年）23号',Transferee:'葛洲坝',time:'2018.11.28',isNew:false},
        {name:'武告字（2018年）23号',Transferee:'葛洲坝',time:'2018.11.28',isNew:false},
    ],
    getlandTableData:[//房企拿地（表格）
        {companyName:'葛洲坝',landName:'武告字（2018年）23号',price:'60,181,128'},
        {companyName:'葛洲坝',landName:'武告字（2018年）23号',price:'60,181,128'},
        {companyName:'葛洲坝',landName:'武告字（2018年）23号',price:'60,181,128'},
        {companyName:'葛洲坝',landName:'武告字（2018年）23号',price:'60,181,128'},
        {companyName:'葛洲坝',landName:'武告字（2018年）23号',price:'60,181,128'},
    ],
    linechartsData:{//成交价格、成交面积趋势(折柱图)
        xAxis:{
            data: [1,2,3,4,5,6,7,8,9,10,11,12],
        },
        series:[
            {
                name: '土地成交面积',
                type: 'line',
                smooth: true, //是否平滑曲线显示
                symbolSize:0,
                lineStyle: {
                    width:0,
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: 'rgba(32, 145, 201, 1)'}, 
                            { offset: 1,  color: 'rgba(32, 145, 201, 0)'}
                        ], false),
    
                    }
                },
                data: [90, 105, 84, 125, 110, 92, 98,88,56,77,56,78]
            },
            {
                name: '土地成交价格',
                type: 'line',
                smooth: true, //是否平滑曲线显示
                symbolSize:0,
                lineStyle: {
                    width:0,
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: 'rgba(210, 177, 25, 1)'}, 
                            { offset: 1,  color: 'rgba(210, 177, 25, 0.2)'}
                        ], false),
                    },
                },
                data: [60, 75, 84, 55, 80, 102, 48,90,79,69,87,90]
            },
        ]
    },




    // 房企项目开工监控系统
    linechartsData2:{//开工面积、开工套数(折线图)
        xAxis:{
            data: [1,2,3,4,5,6,7,8,9,10,11,12],
        },
        yAxis:{
            splitLine: {
                show: true,
                lineStyle:{
                    color: '#C5D0DE',
                    opacity:0.3,
                    width: 1*dpr,
                }
            },
        },
        series:[
            {
                name: '开工面积',
                type: 'line',
                symbolSize:0,
                lineStyle: {
                    width:2*dpr,
                    color:'#F39800'
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: 'rgba(243, 152, 0, 0.5)'}, 
                            { offset: 1,  color: 'rgba(243, 152, 0, 0)'}
                        ], false),
    
                    }
                },
                data: [90, 105, 84, 125, 110, 92, 98,88,56,77,56,78]
            },
            {
                name: '开工套数',
                type: 'line',
                symbolSize:0,
                lineStyle: {
                    width:2*dpr,
                    color:'#02CCFF'
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: 'rgba(2, 204, 255, 0.5)'}, 
                            { offset: 1,  color: 'rgba(2, 204, 255, 0)'}
                        ], false),
                    },
                },
                data: [60, 75, 84, 55, 80, 102, 48,90,79,69,87,90]
            },
        ]
    },

    // 全装修市场监控系统
    linechartsData3:{//装修面积、装修套数(折线图)
        xAxis:{
            data: [1,2,3,4,5,6,7,8,9,10,11,12],
        },
        yAxis:{
            splitLine: {
                show: true,
                lineStyle:{
                    color: '#C5D0DE',
                    opacity:0.3,
                    width: 1*dpr,
                }
            },
        },
        series:[
            {
                name: '装修面积',
                type: 'line',
                symbolSize:0,
                lineStyle: {
                    width:2*dpr,
                    color:'#00FFFF'
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: 'rgba(0, 255, 255, 0.5)'}, 
                            { offset: 1,  color: 'rgba(0, 255, 255, 0)'}
                        ], false),
    
                    }
                },
                data: [90, 105, 84, 125, 110, 92, 98,88,56,77,56,78]
            },
            {
                name: '装修套数',
                type: 'line',
                symbolSize:0,
                lineStyle: {
                    width:2*dpr,
                    color:'#007DEA'
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: 'rgba(0, 125, 234, 0.5)'}, 
                            { offset: 1,  color: 'rgba(0, 125, 234, 0)'}
                        ], false),
                    },
                },
                data: [60, 75, 84, 55, 80, 102, 48,90,79,69,87,90]
            },
        ]
    },
    // pie
    trendPiechartsData1:{//建筑面积占比
        hasCircle:true,
        color:['#00FFFF','#4F748D'],
        title:[
            {
                text: '12,345㎡\n全装修',
                textAlign:'center',
                textStyle: {
                    fontSize: 14*dpr,
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    color: '#FFFFFF'
                },
                left:'49%',
                top:'33%',
            },
        ],
        series:{
            name:'建筑面积占比',
            data:[
                {value:36, name:'全装修'},
                {value:10, name:'毛坯'},
            ]
        }
    },
    trendPiechartsData2:{//装修标准占比
        color:['#07CA99','#EF732E','#FFCC02','#02CCFF'],
        title:[
            {
                text: '装修\n标准',
                textAlign:'center',
                textStyle: {
                    fontSize: 14*dpr,
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    color: '#FFFFFF'
                },
                left:'50%',
                top:'33%',
            },
        ],
        series:{
            name:'装修标准占比',
            center: ['53%', '40%'],
            radius: ['35%', '50%'],
            hoverAnimation: true,
            data:[
                {value:35, name:'4000以上'},
                {value:35, name:'3000-4000'},
                {value:15, name:'2000-3000'},
                {value:25, name:'1000-2000'},
            ]
        }
    },

    // 报告
    lineBarchartsData2:{//成交价格、成交面积趋势(折柱图)
        color:['#00A4DF','#FFCC02'],
        grid:{
            bottom:'5%',
        },
        xAxis:{
            boundaryGap: true,
            axisLabel: { //坐标轴刻度标签的相关设置
                textStyle: {
                    color: '#7F8FA4',
                    margin:15,
                    fontSize: 12*dpr,
                },
            },
            data: ['1/4','1/5','1/6','1/7','1/8','1/9','1/10'],
        },
        yAxis:{
            splitLine: {
                show: true,
                lineStyle:{
                    color: '#C5D0DE',
                    opacity:0.3,
                    width: 1*dpr,
                }
            },
        },
        series:[
            {
                name: '成交面积',
                type: 'bar',
                barWidth: 36*dpr,
                itemStyle: { //区域填充样式
                    // color:'#00A4DF',
                    barBorderRadius: [4*dpr,4*dpr,0,0],
                },
                data: [90, 105, 84, 125, 110, 92, 98]
            },
            {
                name: '成交价格',
                type: 'line',
                lineStyle: {
                    normal:{
                        // color:'#FFCC02',
                        width:3*dpr,
                    }
                },
                symbolSize:0,
                data: [60, 75, 84, 55, 80, 102, 48,]
            },
        ]
    },

    // 列表页
    rosePiechartsData:{//土地属性占比(玫瑰饼图)
        title:{
            text:'土地属性\n占比',
            textStyle:{
                color:'#1D2531',
                align:'center',
                fontSize:14*dpr,
            },
            textAlign:'center',
            left:'49%',
            top:'45%',
        },
        series:{
            roseType : 'area',
            label: {
                normal:{
                    show:true,
                    formatter:[
                        '{value|{c}}{unit|%}',
                        '{label|{b}}',
                    ].join('\n'),
                    position: 'top',
                    fontSize: 12*dpr,
                    rich: {
                        value: {
                            fontSize:20*dpr,
                        },
                        unit: {
                            fontSize:12*dpr,
                        },
                        label: {
                            fontSize:12*dpr,
                            color:'#7F8FA4'
                        }
                    }
                },
            },
            data:[
                {value:36, name:'纯住宅'},
                {value:10, name:'商住'},
                {value:20, name:'商办'},
                {value:10, name:'综合'},
                {value:40, name:'工业'},
                {value:20, name:'其他'},
            ]
        }
    },
    lineBarchartsData:{//成交价格、成交面积趋势(折柱图)
        color:['#00A4DF','#FFCC02'],
        title:{
            text:'成交价格、成交面积趋势',
            textStyle:{
                color:'#1D2531',
                fontSize:14*dpr,
            },
            textAlign:'center',
            left:'50%',
            bottom:0,
        },
        grid:{
            bottom:'20%',
        },
        legend:{
            show:true,
            data: ["成交面积", "成交价格"]
        },
        xAxis:{
            boundaryGap: true,
            axisLabel: { //坐标轴刻度标签的相关设置
                textStyle: {
                    color: '#7F8FA4',
                    margin:15,
                    fontSize: 12*dpr,
                },
            },
            data: ['1/4','1/5','1/6','1/7','1/8','1/9','1/10'],
        },
        yAxis:{
            splitLine: {
                show: true,
                lineStyle:{
                    color: '#C5D0DE',
                    opacity:0.3,
                    width: 1*dpr,
                }
            },
        },
        series:[
            {
                name: '成交面积',
                type: 'bar',
                barWidth: 36*dpr,
                itemStyle: { //区域填充样式
                    // color:'#00A4DF',
                    barBorderRadius: [4*dpr,4*dpr,0,0],
                },
                data: [90, 105, 84, 125, 110, 92, 98]
            },
            {
                name: '成交价格',
                type: 'line',
                lineStyle: {
                    normal:{
                        // color:'#FFCC02',
                        width:3*dpr,
                    }
                },
                symbolSize:0,
                data: [60, 75, 84, 55, 80, 102, 48,]
            },
        ]
    },
    mapBarData:[{
        name: "海门",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "鄂尔多斯",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "青岛",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "拉萨",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "上海",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "攀枝花",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "威海",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "承德",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "厦门",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "汕尾",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "潮州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "丹东",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "烟台",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "福州",
        value: (Math.random() * 200).toFixed(2)
    }, 
    {
        name: "宁波",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "湛江",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "揭阳",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "荣成",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "连云港",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "葫芦岛",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "常熟",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "东莞",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "河源",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "淮安",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "泰州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "南宁",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "营口",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "惠州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "江阴",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "蓬莱",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "韶关",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "嘉峪关",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "广州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "延安",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "太原",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "清远",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "中山",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "昆明",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "寿光",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "盘锦",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "长治",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "深圳",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "珠海",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "宿迁",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "咸阳",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "铜川",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "平度",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "佛山",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "海口",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "江门",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "大连",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "沈阳",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "苏州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "嘉兴",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "长春",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "银川",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "张家港",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "锦州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "南昌",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "三亚",
        value: (Math.random() * 300).toFixed(2)
    }, {
        name: "自贡",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "吉林",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "西宁",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "呼和浩特",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "成都",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "大同",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "桂林",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "张家界",
        value: (Math.random() * 200).toFixed(2)
    },  {
        name: "北海",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "西安",
        value: (Math.random() * 200).toFixed(2)
    }, 
    {
        name: "包头",
        value: (Math.random() * 200).toFixed(2)
    },{
        name: "乌鲁木齐",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "枣庄",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "杭州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "淄博",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "鞍山",
        value: (Math.random() * 200).toFixed(2)
    },{
        name: "库尔勒",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "安阳",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "开封",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "济南",
        value: (Math.random() * 100).toFixed(2)
    },  {
        name: "温州",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "九江",
        value: (Math.random() * 100).toFixed(2)
    }, {
        name: "邯郸",
        value: (Math.random() * 200).toFixed(2)
    },  {
        name: "兰州",
        value: (Math.random() * 200).toFixed(2)
    }, 
    {
        name: "秦皇岛",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "石家庄",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "保定",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "湘潭",
        value: (Math.random() * 100).toFixed(2)
    }, {
        name: "长沙",
        value: (Math.random() * 100).toFixed(2)
    },{
        name: "廊坊",
        value: (Math.random() * 200).toFixed(2)
    },{
        name: "合肥",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "武汉",
        value: (Math.random() * 200).toFixed(2)
    }, {
        name: "大庆",
        value: (Math.random() * 200).toFixed(2)
    }],

    mapDetailData:[
        {
            boundary:"117.381433, 40.237479;117.396173, 40.233023;117.398323, 40.228016;117.385633, 40.22051;117.385488, 40.213747;117.394002, 40.211843;117.394775, 40.209262;117.386247, 40.206236;117.38967, 40.195669;117.413278, 40.192952;117.395156, 40.182728;117.37448, 40.185472;117.357973, 40.178041;117.364251, 40.164965;117.350507, 40.148507;117.31745, 40.143689;117.306963, 40.129209;117.290894, 40.12602;117.280361, 40.116297;117.273321, 40.114754;117.256015, 40.119775;117.244848, 40.117827;117.231708, 40.105085;117.219913, 40.10159;117.215404, 40.089731;117.203322, 40.087798;117.193646, 40.091574;117.182533, 40.078814;117.170997, 40.083006;117.159169, 40.07399;117.143746, 40.071668;117.137033, 40.072032;117.123396, 40.078602;117.092987, 40.082965;117.089086, 40.072544;117.075532, 40.067039;117.06007, 40.064829;117.05353, 40.056453;117.046581, 40.054257;117.029866, 40.041046;117.014172, 40.038171;116.993799, 40.045743;116.980119, 40.047077;116.977712, 40.053129;116.969296, 40.056837;116.958357, 40.053272;116.940696, 40.055333;116.898478, 40.052887;116.87546, 40.04645;116.851872, 40.057461;116.837801, 40.055244;116.818976, 40.036618;116.792425, 40.038168;116.780139, 40.035721;116.782182, 40.028036;116.776693, 40.01556;116.781965, 39.999829;116.762872, 39.969579;116.767197, 39.962911;116.778486, 39.960863;116.789888, 39.953073;116.787807, 39.936647;116.790506, 39.925763;116.787663, 39.920523;116.791805, 39.905655;116.788332, 39.895925;116.795498, 39.890232;116.801372, 39.890003;116.812893, 39.897195;116.8226, 39.898278;116.82926, 39.89398;116.840155, 39.872218;116.849415, 39.863698;116.891887, 39.851809;116.90332, 39.838454;116.911381, 39.836229;116.914449, 39.839773;116.908476, 39.85238;116.911215, 39.857405;116.915577, 39.857951;116.926073, 39.85234;116.933338, 39.840986;116.934955, 39.822383;116.952008, 39.787391;116.92642, 39.786473;116.909325, 39.769441;116.919842, 39.744989;116.912522, 39.736925;116.897225, 39.731093;116.89476, 39.716832;116.914488, 39.687314;116.904705, 39.678455;116.89389, 39.683627;116.879713, 39.676643;116.870344, 39.676595;116.864162, 39.673564;116.8587, 39.666798;116.859773, 39.65936;116.848583, 39.652644;116.844193, 39.641245;116.848726, 39.628523;116.82715, 39.620201;116.805105, 39.617173;116.792124, 39.604546;116.780313, 39.605478;116.775173, 39.614041;116.765205, 39.62178;116.748982, 39.623477;116.714438, 39.620189;116.71637, 39.613995;116.728086, 39.609701;116.710468, 39.599876;116.701745, 39.60451;116.673363, 39.609935;116.63644, 39.606442;116.618944, 39.628629;116.610577, 39.629852;116.582669, 39.626207;116.577529, 39.621966;116.57452, 39.609939;116.56257, 39.603818;116.554845, 39.603896;116.550029, 39.608001;116.539943, 39.6051;116.533537, 39.599925;116.533441, 39.580088;116.514741, 39.561168;116.507235, 39.562618;116.48695, 39.555863;116.4821, 39.543784;116.469509, 39.538592;116.450737, 39.535575;116.44157, 39.521807;116.422374, 39.529305;116.411754, 39.520478;116.427091, 39.507578;116.423565, 39.498397;116.443715, 39.494768;116.454391, 39.483755;116.461077, 39.459314;116.45876, 39.453338;116.449037, 39.447444;116.438896, 39.446875;116.425962, 39.453909;116.395975, 39.458828;116.380362, 39.458267;116.367919, 39.45421;116.349994, 39.455207;116.33155, 39.469752;116.315295, 39.489351;116.26345, 39.508095;116.251257, 39.530095;116.25443, 39.534478;116.25263, 39.550753;116.244258, 39.558461;116.240682, 39.569154;116.235353, 39.571404;116.227572, 39.584595;116.212702, 39.58242;116.202093, 39.587801;116.1687, 39.587186;116.147503, 39.573407;116.123985, 39.572205;116.108999, 39.581202;116.046326, 39.579602;116.037697, 39.583127;116.028543, 39.591893;116.025186, 39.592165;116.015906, 39.582489;116.009878, 39.582608;115.993611, 39.597266;115.986615, 39.594828;115.976396, 39.57505;115.96471, 39.570514;115.950645, 39.573816;115.9372, 39.594882;115.929165, 39.599158;115.922691, 39.596793;115.922407, 39.585915;115.917023, 39.573661;115.901841, 39.571561;115.888975, 39.55637;115.872911, 39.553265;115.859017, 39.558777;115.852697, 39.548753;115.829538, 39.539875;115.827448, 39.53077;115.836295, 39.517548;115.83269, 39.514032;115.815826, 39.516986;115.79405, 39.515001;115.774421, 39.520611;115.762153, 39.520421;115.755791, 39.526055;115.743952, 39.550644;115.731301, 39.555898;115.712055, 39.571815;115.695956, 39.604569;115.681773, 39.612552;115.673247, 39.611313;115.657767, 39.603499;115.649192, 39.609672;115.642709, 39.610334;115.633884, 39.606324;115.623908, 39.607889;115.612452, 39.605672;115.59729, 39.608223;115.58326, 39.602;115.557664, 39.620221;115.533354, 39.618698;115.523915, 39.610867;115.520989, 39.612917;115.530466, 39.625139;115.530879, 39.645812;115.51657, 39.647544;115.516901, 39.654358;115.511297, 39.656613;115.496137, 39.658511;115.489552, 39.668992;115.502455, 39.676897;115.50778, 39.687211;115.498358, 39.704847;115.500599, 39.715045;115.496586, 39.736027;115.49914, 39.743859;115.485389, 39.748772;115.475743, 39.746463;115.448006, 39.758035;115.428692, 39.769665;115.445447, 39.790329;115.465374, 39.788838;115.49039, 39.803356;115.499596, 39.800185;115.514457, 39.787855;115.52219, 39.794601;115.560199, 39.800814;115.570313, 39.808205;115.577139, 39.818877;115.553027, 39.832854;115.523888, 39.843853;115.521843, 39.847106;115.529616, 39.863487;115.529591, 39.871396;115.53781, 39.880019;115.518779, 39.887512;115.519472, 39.893291;115.531318, 39.905298;115.528905, 39.908131;115.512212, 39.921191;115.495874, 39.929274;115.486364, 39.942998;115.468038, 39.94676;115.44843, 39.958177;115.433585, 39.957051;115.43223, 39.959407;115.431798, 39.979378;115.444819, 39.998452;115.457529, 40.001467;115.457582, 40.007652;115.450351, 40.017268;115.463295, 40.034775;115.486744, 40.041393;115.512932, 40.063;115.514512, 40.068364;115.529682, 40.078267;115.542016, 40.084369;115.550597, 40.083234;115.560378, 40.087223;115.563343, 40.089347;115.563863, 40.098869;115.571755, 40.10332;115.581011, 40.105528;115.589622, 40.101784;115.613694, 40.100135;115.609047, 40.104671;115.612945, 40.11396;115.611444, 40.121535;115.616536, 40.125267;115.645786, 40.123189;115.654327, 40.134463;115.661238, 40.137067;115.681959, 40.136092;115.717095, 40.140681;115.735889, 40.134911;115.747112, 40.137384;115.762398, 40.151299;115.758838, 40.160942;115.762193, 40.166701;115.774005, 40.171125;115.781883, 40.179795;115.793547, 40.184877;115.796893, 40.184445;115.809948, 40.162448;115.828792, 40.158812;115.846905, 40.149959;115.855287, 40.151262;115.860853, 40.15681;115.853614, 40.173378;115.857525, 40.180552;115.864726, 40.189149;115.878734, 40.194056;115.884356, 40.205409;115.893882, 40.212535;115.892296, 40.223584;115.902145, 40.235946;115.908246, 40.239878;115.919047, 40.240327;115.926564, 40.25324;115.94159, 40.260512;115.967002, 40.262199;115.974252, 40.266868;115.97471, 40.269838;115.958783, 40.283039;115.953389, 40.291729;115.947082, 40.313173;115.948694, 40.318363;115.940429, 40.322164;115.937001, 40.32777;115.923957, 40.361316;115.905977, 40.362949;115.890735, 40.360361;115.879447, 40.366761;115.870472, 40.384428;115.838633, 40.396001;115.827921, 40.415544;115.81378, 40.431064;115.792453, 40.447329;115.783379, 40.450251;115.775515, 40.459529;115.772628, 40.467393;115.788917, 40.497475;115.772462, 40.504255;115.748089, 40.50439;115.74524, 40.506505;115.753654, 40.526891;115.761151, 40.535336;115.762141, 40.544406;115.797724, 40.566372;115.825258, 40.563377;115.83387, 40.589144;115.838328, 40.59364;115.862658, 40.595842;115.877655, 40.60118;115.894744, 40.600768;115.913626, 40.621733;115.949104, 40.618177;115.96066, 40.608389;115.981228, 40.602685;115.98862, 40.587938;115.999853, 40.579074;116.01022, 40.581125;116.013185, 40.588177;116.027508, 40.60266;116.03802, 40.602562;116.074371, 40.616137;116.117469, 40.619994;116.130013, 40.630216;116.119155, 40.650283;116.1323, 40.659262;116.142538, 40.671277;116.156802, 40.66991;116.172729, 40.672774;116.17971, 40.704866;116.192772, 40.72329;116.211424, 40.721544;116.218114, 40.728609;116.221954, 40.73785;116.223798, 40.762555;116.228252, 40.764704;116.241009, 40.763925;116.237326, 40.772223;116.242425, 40.788662;116.255298, 40.795696;116.272504, 40.785514;116.282805, 40.769493;116.295495, 40.769182;116.314222, 40.759837;116.320059, 40.773597;116.337734, 40.779425;116.362897, 40.776096;116.390477, 40.779535;116.410431, 40.785618;116.423865, 40.777205;116.421743, 40.770313;116.425896, 40.768906;116.450491, 40.774229;116.464207, 40.772793;116.471766, 40.776871;116.464131, 40.802518;116.449836, 40.81165;116.445873, 40.821845;116.4147, 40.838824;116.397866, 40.867309;116.387382, 40.872168;116.343852, 40.908911;116.345869, 40.933579;116.372599, 40.948687;116.378173, 40.949332;116.3837, 40.945619;116.403818, 40.914519;116.40899, 40.911565;116.41909, 40.907366;116.435043, 40.908496;116.446375, 40.904089;116.46108, 40.906109;116.48041, 40.900732;116.484007, 40.906772;116.48056, 40.923798;116.456527, 40.958047;116.463577, 40.986171;116.470536, 40.988067;116.481827, 40.983534;116.493858, 40.98769;116.508245, 40.982177;116.523775, 40.981191;116.544638, 40.994723;116.563513, 40.993015;116.570329, 40.997957;116.57676, 40.996674;116.594187, 40.98326;116.606649, 40.981131;116.616345, 40.986788;116.623991, 41.001611;116.621849, 41.00966;116.628373, 41.030876;116.620424, 41.043936;116.62331, 41.059666;116.632438, 41.061437;116.6373, 41.066571;116.654404, 41.064647;116.667039, 41.054673;116.68719, 41.046956;116.696952, 41.048648;116.705198, 41.026593;116.69719, 41.011775;116.690301, 41.007372;116.690903, 40.98785;116.684864, 40.97669;116.695418, 40.963802;116.699131, 40.952962;116.71181, 40.939846;116.725403, 40.940236;116.729481, 40.936775;116.721943, 40.922882;116.722422, 40.91554;116.733405, 40.906516;116.764465, 40.895877;116.766296, 40.887377;116.775619, 40.888796;116.786667, 40.882356;116.800816, 40.869974;116.811716, 40.845949;116.818494, 40.853081;116.823872, 40.854079;116.833373, 40.845851;116.843083, 40.847274;116.863325, 40.840445;116.870218, 40.832099;116.883553, 40.825919;116.889811, 40.810243;116.902653, 40.801443;116.902943, 40.784915;116.931147, 40.77877;116.927406, 40.765894;116.935412, 40.751498;116.945245, 40.746819;116.949304, 40.737669;116.984871, 40.709644;117.017136, 40.699632;117.028055, 40.700842;117.037605, 40.697878;117.049208, 40.703624;117.064915, 40.706499;117.080841, 40.704888;117.114585, 40.713252;117.125165, 40.708249;117.148485, 40.70336;117.170671, 40.70456;117.18516, 40.700911;117.201332, 40.702449;117.225974, 40.695886;117.24689, 40.683965;117.272055, 40.685153;117.289122, 40.66823;117.314149, 40.663591;117.340438, 40.667591;117.345931, 40.676765;117.353724, 40.681815;117.364528, 40.679956;117.394848, 40.689379;117.425953, 40.692501;117.446943, 40.688111;117.453483, 40.681636;117.479203, 40.680117;117.491871, 40.68406;117.515852, 40.673114;117.52171, 40.663429;117.511429, 40.658997;117.511007, 40.648917;117.507003, 40.642723;117.48704, 40.641004;117.476568, 40.654893;117.465352, 40.656782;117.457236, 40.649864;117.428678, 40.64354;117.427172, 40.625368;117.420448, 40.609412;117.435473, 40.581286;117.430056, 40.575951;117.426328, 40.574141;117.410392, 40.579248;117.404707, 40.574187;117.389104, 40.569176;117.363349, 40.584973;117.317891, 40.582504;117.307539, 40.574315;117.286139, 40.566324;117.277752, 40.565815;117.256622, 40.553286;117.256057, 40.544633;117.267538, 40.527114;117.268861, 40.51908;117.253936, 40.519024;117.245092, 40.522989;117.238204, 40.51832;117.223712, 40.519157;117.215303, 40.504503;117.226014, 40.499968;117.233853, 40.48937;117.234129, 40.48107;117.243896, 40.475828;117.242876, 40.46462;117.254214, 40.459603;117.270937, 40.446525;117.263894, 40.43746;117.243686, 40.423576;117.243988, 40.409497;117.24752, 40.403527;117.230966, 40.381898;117.232685, 40.376833;117.248447, 40.37567;117.258192, 40.365671;117.267834, 40.34357;117.28307, 40.340806;117.278993, 40.330982;117.280877, 40.319499;117.284811, 40.312361;117.300214, 40.301103;117.301774, 40.286096;117.30714, 40.282766;117.320218, 40.283732;117.329947, 40.280303;117.342331, 40.282246;117.354381, 40.239876;117.358155, 40.236968;117.381433, 40.237479",
            name:'武告字（2018年）23号',
            invisor:'葛洲坝',
            coversArea:'31,233,330㎡',
            salesPrice:'56,233,330万元',
            center:[116.404, 39.915]
        }
    ],

    reportMockData:{
        title:"2018年全国重点70城全装修建面排行榜",
        sContent:[
            {
                type:"txt",
                data:"住宅全装修是指<span>商品住宅</span>交付使用前，所有功能区间的固定面全部铺装或粉刷完成，设备管线及开关插座等全部安装完成，厨房和卫生间的基本设备全部安装到位。全装修可以有效的避免二次装修产生的粉尘、装修废弃物污染与小区住户二次装修造成的噪声交叉干扰等问题，逐渐受到居民的认可。",
            },
            {
                type:"chart",
                data:{
                    chartType:'pie',
                    title:'2018年全国重点70城各性质拿地建面占比',
                    unit:'%',
                    chartData:[
                        {value:26, name: '纯住宅'},
                        {value:23, name: '商住'},
                        {value:12, name: '商办'},
                        {value:12, name: '工业'},
                        {value:12, name: '综合'},
                        {value:12, name: '其他'},
                    ]
                },
            },
            {
                type:"table",
                data:{
                    title:'2018年全国重点70城全装修建面比例变化趋势图',
                    tableHead:[
                        {
                            prop:'num',
                            label:'序号',
                        },
                        {
                            prop:'companyName',
                            label:'企业名称',
                        },
                        {
                            prop:'newArea',
                            label:'新开盘建面',
                            unit:'万㎡',
                        },
                        {
                            // prop:'allArea',
                            label:'全装修建面',
                            unit:'万㎡',
                            children:[
                                {
                                    prop:'planArea',
                                    label:'规划建面',
                                },
                                {
                                    prop:'presignArea',
                                    label:'预征建面',
                                }
                            ]
                        },
                    ],
                    tableData: [
                        {
                            num: '1',
                            companyName: '碧桂园',
                            newArea: '8713',
                            planArea: '345,12.24',
                            presignArea: '345,12.24',
                        },
                        {
                            num: '2',
                            companyName: '碧桂园',
                            newArea: '8713',
                            planArea: '345,12.24',
                            presignArea: '345,12.24',
                        },
                    ]
                },
            },
            {
                type:"chart",
                data:{
                    chartType:'line_bar',
                    title:'2018年全国重点70城全装修建面比例变化趋势图',
                    xAxisData:['2017年2-12月','2018年1-3月','2018年1-6月','2018年1-9月','2018年1-12月'],
                    chartData:[
                        {name: '新开盘建面', type:'bar', unit:'万㎡', value:[2.0, 4.9, 7.0, 23.2, 25.6]},
                        {name: '全装修建面', type:'bar', unit:'万㎡', value:[2.0, 4.9, 7.0, 23.2, 25.6]},
                        {name: '全装修建面比例', type:'line', unit:'%', value:[2.0, 4.9, 7.0, 23.2, 25.6]},
                    ]
                },
            },
            {
                type:"chart",
                data:{
                    chartType:'bar',
                    title:'2018年全国重点70城全装修建面比例变化趋势图',
                    xAxisData:['2017年2-12月','2018年1-3月','2018年1-6月','2018年1-9月','2018年1-12月'],
                    chartData:[
                        {name: '新开盘建面', type:'bar', unit:'万㎡', value:[2.0, 4.9, 7.0, 23.2, 25.6]},
                        // {name: '全装修建面', type:'bar', unit:'万㎡', value:[2.0, 4.9, 7.0, 23.2, 25.6]},
                    ]
                },
            },
            {
                type:"chart",
                data:{
                    chartType:'stackbar',
                    title:'2018年全国重点70城全装修建面比例变化趋势图',
                    xAxisData:['碧桂园','万科地产','中国恒大'],
                    chartData:[
                        {name: '全装修证征建面', type:'bar', unit:'万㎡', value:[2.0, 4.9, 7.0]},
                        {name: '全装修证征建面2', type:'bar', unit:'万㎡', value:[2.0, 4.9, 7.0]},
                    ]
                }
            },
            {
                type:"chart",
                data:{
                    chartType:'stackbar_Horizontal',
                    title:'2018年全国重点70城全装修建面比例变化趋势图',
                    xAxisData:['全装修预证建面','全装修预证户数'],
                    chartData:[
                        {name: '一线', type:'bar', unit:'万㎡', value:[2.0, 4.9]},
                        {name: '二线', type:'bar', unit:'万㎡', value:[2.0, 7.0]},
                    ]
                }
            },
            {
                type:"table",
                data:{
                    title:'2018年全国重点70城全装修建面比例变化趋势图',
                    tableHead:[
                        {
                            prop:'num',
                            label:'序号',
                        },
                        {
                            prop:'companyName',
                            label:'企业名称',
                        },
                        {
                            prop:'newArea',
                            label:'新开盘建面',
                            unit:'万㎡',
                        },
                        {
                            prop:'companyName',
                            label:'企业名称',
                        },
                        {
                            prop:'newArea',
                            label:'新开盘建面',
                            unit:'万㎡',
                        },
                    ],
                    tableData: [
                        {
                            num: '1',
                            companyName: '碧桂园',
                            newArea: '8713',
                            planArea: '345,12.24',
                            presignArea: '345,12.24',
                        },
                        {
                            num: '2',
                            companyName: '碧桂园',
                            newArea: '8713',
                            planArea: '345,12.24',
                            presignArea: '345,12.24',
                        },
                    ]
                },
            },
        ]
    }
}
export default mockData 